// @flow
import React, { Component } from 'react';

type Props = {
  disabled?: boolean,
  min: number,
  max: number,
  id: string,
  initialValue: number,
  onChange: (number, string) => void,
};

type State = {
  isDragging: boolean,
  value: number,
};

export default class BulmaSlider extends Component<Props, State> {
  handleChange: Function;
  handleMouseDown: Function;
  handleMouseUp: Function;
  slider: ?HTMLInputElement;

  state = { isDragging: false, value: 0 };

  constructor() {
    super();

    this.handleChange = this.handleChange.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
  }

  componentDidMount() {
    this.setState({ value: Math.round(this.props.initialValue) });
  }

  componentWillReceiveProps(nextProps: Props) {
    if (this.props.initialValue !== nextProps.initialValue) {
      this.setState({ value: Math.round(nextProps.initialValue) });
    }
  }

  handleChange(e: SyntheticMouseEvent<HTMLInputElement>) {
    const value = parseInt(e.currentTarget.value, 10);
    this.setState({ value });
  }

  handleMouseDown() {
    this.setState({ isDragging: true });
  }

  handleMouseUp() {
    this.setState({ isDragging: false });

    // Call onChange prop here so we don't have to debounce
    this.props.onChange(this.state.value, this.props.id);
  }

  render() {
    const LABEL_WIDTH = 35;
    const LABEL_OFFSET_V = 48;
    const { disabled, id, min, max } = this.props;
    const { isDragging, value } = this.state;
    let left = 0;
    let top = 0;
    if (this.slider) {
      const rect = this.slider.getBoundingClientRect();
      const newPoint = (value - min) / (max - min);
      let newPlace = 0;

      if (newPoint < 0) {
        newPlace = 0;
      } else if (newPoint > 1) {
        newPlace = rect.width;
      } else {
        newPlace = rect.width * newPoint;
      }

      left = rect.left - LABEL_WIDTH / 2 + newPlace;
      top = rect.top - LABEL_OFFSET_V;
    }

    return (
      <div>
        <div
          className="slider-drag-label"
          style={{
            left,
            top,
            opacity: isDragging ? 1.0 : 0,
          }}
        >
          {value}
        </div>
        <div className="slider-label-container">
          <label className="slider-label-left" htmlFor={id}>
            {min}
          </label>
        </div>
        <input
          className="slider"
          disabled={disabled}
          id={id}
          max={max}
          min={min}
          onChange={this.handleChange}
          onMouseDown={this.handleMouseDown}
          onMouseUp={this.handleMouseUp}
          ref={c => {
            this.slider = c;
          }}
          step="1"
          title={value}
          type="range"
          value={value}
        />
        <div className="slider-label-container">
          <label className="slider-label-right" htmlFor={id}>
            {max}
          </label>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/view/Pages/CatalogsPage/BulmaSlider.js